export default {
	label: 'Change history',
	changeNotice: '{firstname} {lastname} made {count} change {time}: | {firstname} {lastname} made {count} changes {time}:',
	method: {
		title: 'Measure',
		fields: {
			status: 'Status',
			due_date: 'Due date',
			priority: 'Priority',
			comment: 'Comment',
			price: 'Price',
			responsible: 'Responsible',
			updated_at: 'Last review',
			jira_url: 'Jira URL',
		},
	},
	rules: {
		label: 'Rules',
		fields: {
			status: 'Status',
			comment: 'Comment',
		},
	},
}
